var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.keyword&&_vm.matchTypes)?_c('div',{staticStyle:{"font-size":"12px"}},[_vm._v(" [ "+_vm._s(_vm.keyword)+" ] 是 "),_c('span',{staticClass:"color-warning"},[_vm._v(_vm._s(_vm.matchTypes))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }